import React, { useContext, useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import SidePanelSections from './SidePanelSections';
import { useGetSectionClassList, useGetSectionsByBookId, useGetSectionStructureType } from '../../../../hooks/services/sBook/useOfSection'
import '../../../../styles/css/RelatedConcept.css'
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import SecctionCard from './SecctionCard';
import ToolBar from '../../../../components/Common/Toolbar';
import { createSectionsByBookId, getSectionStructureConcept } from '../../../../services/sBook/section.service'
import NoDataLayer from '../../../Common/NoDataLayer'
import StatusHeaderItem from '../StatusHeaderItem';
import Message from '../../../Common/Message';
import { saveBook } from "../../../../services/sBook/book.service";
import { ActionButton, DefaultButton, Dialog, DialogContent, DialogFooter, DialogType, Dropdown, PrimaryButton } from '@fluentui/react';
import CLabel from '../../../Common/CLabel';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero } from '../../../../common/Helpers';
import CValidator from '../../../Common/CValidator';
import MainAppContext from '../../../../MainAppContext';

function SectionCreationBox(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_SetBookObject = props.setBookObject;
    
    const inputParam_BookPartyCount = props.bookPartyCount;
    const inputParam_BookPartyList = props.bookPartyList;
    
    const inputParam_SetterBookSectionList = props.setterBookSectionList;
    const inputParam_SetterSelectedCard = props.setterSelectedCard;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_SetSectionCardIsSelected = props.setSectionCardIsSelected !== null && props.setSectionCardIsSelected !== undefined ? props.setSectionCardIsSelected : null;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;
    const inputParam_StatusFly = props.statusFly !== null && props.statusFly !== undefined ? props.statusFly : null;
    const inputParam_FireGetSectionStructure = props.fireGetSectionStructure !== null && props.fireGetSectionStructure !== undefined ? props.fireGetSectionStructure : false;
    const inputParam_SetFireGetSectionStructure = props.setFireGetSectionStructure !== null && props.setFireGetSectionStructure !== undefined ? props.setFireGetSectionStructure : false;

    const [message, setMessage] = useState(null);
    const [successful, setSuccessful] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const [sectionStructureType, setSectionStructureType] = useState(null);
    const [sectionStructureIsValid, setSectionStructureIsValid] = useState(null);

    const [structureSectionAlertFired, setStructureSectionAlertFired] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [bookSectionList, setBookSectionList] = useState(null);
    const [selectInitialData, setSelectInitialData] = useState(true);
    useGetSectionsByBookId(inputParam_BookObject.id, bookSectionList, setBookSectionList, inputParam_SetterBookSectionList, null, selectInitialData, bookSectionList, true, setSelectInitialData)
    
    useGetSectionStructureType(inputParam_BookObject.id, sectionStructureType, setSectionStructureType, inputParam_FireGetSectionStructure, inputParam_SetFireGetSectionStructure)

    const [sectionClassList, setSectionClassList] = useState(null);
    useGetSectionClassList(sectionClassList, setSectionClassList);

    const selectCard = (card) => {
        inputParam_SetterSelectedCard(card)
        setSelectedCard(card)
        inputParam_SetSectionCardIsSelected && inputParam_SetSectionCardIsSelected(true)
    };

    const validateSectionClassInSectionList = (listadoObjetos, listadoClassId, idsOmitidos = []) => {
        const listadoClassIdHitos = listadoClassId.filter(x => !isNullUndefinedOrEmpty(x.milestoneCode));
        const hasItemWithHito = listadoObjetos.some(itemMain =>
            listadoClassIdHitos.some(itemClassId => itemClassId.key === itemMain.sectionClassId)
        );
        
        return hasItemWithHito;
    }

    const onPreCreateSection = (e) => {
        let milestoneValidationOk = true
        if (inputParam_BookObject.hasMilestone === true) {
            milestoneValidationOk = bookSectionList.data.data.filter(x => isNullUndefinedOrEmptyOrZero(x.sectionClassId)).length === 0

            if (milestoneValidationOk === true) {
                milestoneValidationOk = validateSectionClassInSectionList(bookSectionList.data.data, sectionClassList, [0])

                if (milestoneValidationOk === false) {
                    setShowMessage(true);
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-sectionclassneeded'));

                    return;
                }
            }
        }

        if (milestoneValidationOk) {
            if (structureSectionAlertFired === false) {
                setStructureSectionAlertFired(true);
            } else {
                //alert("Debe crear el libro primero.");
            }
        }
        else {
            setShowMessage(true);
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-sectionclassneeded'));
        }
    };

    const onCreateSection = (e) => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelOpen(true);
        } else {
            //alert("Debe crear el libro primero.");
        }
    };

    const onGetSectionStructure = (e) => {
        if (inputParam_BookObject.id !== 0 && sectionStructureIsValid === true) {
            getSectionStructureConcept(inputParam_BookObject.sectionStructureId).then((response) => {
                if (response.data.succeeded) {

                    response.data.data.map(x => {
                        x.requiresApproval = inputParam_BookObject.requiresApproval;
                    })

                    setBookSectionList(response)
                    inputParam_SetterBookSectionList(response)

                    setSectionStructureIsValid(true);
                    setShowMessage(false);
                }
                else {
                    setShowMessage(true)
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setSectionStructureIsValid(false)
        }
    }

    const onSaveSection = () => {
        let bookSectionToSave = bookSectionList.data.data.filter(x => x.id <= 0);
        
        if (bookSectionToSave.length > 0) {
            createSectionsByBookId(inputParam_BookObject.id, bookSectionToSave).then((response) => {
                saveBook(inputParam_BookObject).then(() => {
                    setShowMessage(true)
                    setSuccessful(true);
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))

                    setBookSectionList(response)
                    inputParam_SetterBookSectionList && inputParam_SetterBookSectionList(response)
                    inputParam_SetBookObject && inputParam_SetBookObject(inputParam_BookObject);
                }).catch(() => {
                    setShowMessage(true)
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("warning");
            setMessage(t('data-lang-msg-nodatatosave'))
        }
    };

    const setSelectedSections = (sections) => {

        sections.forEach(section => {
            const sectionFound = bookSectionList.data.data.find(x => section.sectionCode === " " ? x.id === section.id : x.sectionCode === section.sectionCode)
            
            if (sectionFound === null || sectionFound === undefined) {
                bookSectionList.data.data.push(section);
            }
        });

        setBookSectionList(bookSectionList)
    };

    const onDeleteSection = (section) => {
        let auxArray = []

        //Quitar la party eliminada del array de partys, asi no se debe ir a buscarnuevamente la data.
        //.silice no funciona por alguna razon.
        if (section !== null) {
            for (let index = 0; index < bookSectionList.data.data.length; index++) {
                const element = bookSectionList.data.data[index];
    
                if (section.id !== 0) {
                    if (!(element.id === section.id)) {
                        auxArray.push(element);
                    }
                } else {
                    if (!(element.sectionCode === section.sectionCode && (element.name === section.name && element.requiresApproval === section.requiresApproval))) {
                        auxArray.push(element);
                    }
                }
            }

            setBookSectionList({data: {data: auxArray}});
            inputParam_SetterBookSectionList({data: {data: auxArray}});

            setShowMessage(true)
            setSuccessful(true);
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        } else {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        }
    };

    const handleDropdownChange = (event, option) => {
        const aux_obj = {...inputParam_BookObject}
        aux_obj.sectionStructureId = option.key
        inputParam_SetBookObject && inputParam_SetBookObject(aux_obj);

        setSectionStructureIsValid((option.key !== 0))
    }

    const displaySectionBox = inputParam_BookObject.id !== null && inputParam_BookPartyCount !== 0 && (inputParam_BookObject.hasMilestone ? (!isNullUndefined(inputParam_BookPartyList.data.data.find(x => x.counterParty === true)) && !isNullUndefined(inputParam_BookPartyList.data.data.find(x => x.manager === true))) : true);
    
    const onHideDialog = (ev) => {
        ev.preventDefault();
        setStructureSectionAlertFired(false);
    };

    const onAcceptCreation = (ev) => {
        ev.preventDefault();
        onSaveSection();
        setStructureSectionAlertFired(false);
    };

    return (
        <>
            <Card className='book-section-form h-100'>
                <DisabledCard display={ !displaySectionBox } />
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <Row>
                            {
                                inputParam_EditMode === true && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                                <Col className='col-auto ms-auto'>
                                    <StatusHeaderItem index={ 4 } statusId={ inputParam_BookObject.statusId } />
                                </Col>
                            }
                            <Col className={ inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) ? "ps-4 ms-3" : "" } >
                                <b>{t('data-lang-boxname-book-section')}</b>
                            </Col>
                        </Row>
                    </Card.Title>
                </Card.Header>
                <Card.Footer className='w-100' style={{padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar'>
                        <Row>
                            <Col className='col-auto me-auto my-auto ms-2 pt-1 d-flex'>
                                <CLabel className="pt-2" labelText={ t('data-lang-lbl-importsectionstructure') } />
                                {
                                    inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) && sectionStructureType &&
                                    <>
                                        <Dropdown
                                            selectedKey={!isNullUndefined(inputParam_BookObject.sectionStructureId) ? inputParam_BookObject.sectionStructureId : 0}
                                            options={sectionStructureType}
                                            onChange={handleDropdownChange}
                                            styles={{ dropdown: { width: '150px' } }}
                                            className='my-auto'
                                            disabled={!(inputParam_StatusFly < 4)}
                                        />
                                        {
                                            sectionStructureIsValid === false && inputParam_StatusFly < 4 &&
                                            <CValidator inValidText="*" isInValid={!sectionStructureIsValid} />
                                        }
                                        {
                                            inputParam_StatusFly < 4 &&
                                            <ActionButton
                                                className='px-1'
                                                key='createStructure'
                                                onClick={onGetSectionStructure}
                                                allowDisabledFocus
                                                iconProps={{ iconName: 'CircleAddition' }} text={t('data-lang-btn-createstructure')}
                                            />
                                        }
                                    </>
                                }
                            </Col>
                            <Col className='col col-auto ms-auto d-flex'>
                            {
                                inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                                <>
                                    <ActionButton
                                        className='px-1'
                                        key='save'
                                        onClick={onPreCreateSection}
                                        allowDisabledFocus iconProps={{ iconName: 'Save' }}
                                        text={t('data-lang-btn-save')}
                                        disabled={bookSectionList !== null && (bookSectionList.data.data.filter(x => x.id <= 0).length > 0) ? false : true}
                                    />
                                    <ActionButton
                                        className='px-1'
                                        key='create'
                                        onClick={onCreateSection}
                                        allowDisabledFocus
                                        iconProps={{ iconName: 'CircleAddition' }} text={`${t('data-lang-btn-create')}${(!isNullUndefined(bookSectionList) && !isNullUndefined(bookSectionList.data.data) && bookSectionList.data.data.length > 0) ? `/${t('data-lang-btn-edit')}` : ''}`}
                                    />
                                </>
                                //<ToolBar items={ toolBarItems_Sections } display={displaySectionBox} />
                            }
                            </Col>
                        </Row>
                    </div>
                </Card.Footer>
                <Card.Body className="book-section-form-body pt-2 w-100 h-100">
                    <Row className='layerBlockedContent'>
                        {
                            displaySectionBox &&
                            <>
                                {
                                    bookSectionList && bookSectionList.data.data.map((section, index) => 
                                        <Col className={`mb-2`} key={ index } xs={12} sm={12} md={6} lg={6} xl={6} xxl={3}>
                                            <SecctionCard
                                                editMode={ inputParam_EditMode }
                                                userHasConfigRoleAction={(inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction)}
                                                bookId={ inputParam_BookObject.id }
                                                key={ index }
                                                selectedCard={selectedCard}
                                                sectionItem={ section }
                                                setterDeleteSection={ onDeleteSection }
                                                setterSelectedCard={ selectCard }
                                                sectionClassList={sectionClassList}
                                                setterMessage={ setMessage } setterShowMessage={setShowMessage} setterSuccessful={setSuccessful} setterMessageType={ setMessageType }
                                            />
                                        </Col>
                                    )
                                }
                                {
                                    (bookSectionList && bookSectionList.data.data.length === 0) && 
                                    <NoDataLayer display={ !displaySectionBox } />
                                }
                                {
                                    isPanelOpen && bookSectionList && sectionClassList &&
                                    <SidePanelSections
                                        bookId={ inputParam_BookObject.id }
                                        objBook={ inputParam_BookObject }
                                        mainSectionList = { !isNullUndefined(bookSectionList.data) && !isNullUndefined(bookSectionList.data.data) ? bookSectionList.data.data : [] }
                                        isPanelOpen={ isPanelOpen }
                                        setterSelectedItems={ setSelectedSections }
                                        setterIsPanelOpen={ setIsPanelOpen }
                                        sectionClassList={sectionClassList}
                                    />
                                }
                            </>
                        }
                        <NoDataLayer display={ !displaySectionBox } />
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Message message={ ((inputParam_BookObject.hasMilestone === true) ? t('data-lang-msg-bookwithmilestonealert') : t('data-lang-msg-bookwithoutmilestonealert')) } display={ true } messageType={ 'warning' } setterShowMessage={ undefined } />
                    <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                </Card.Footer>
            </Card>
            {
                structureSectionAlertFired && 
                <Dialog
                    hidden={!structureSectionAlertFired}
                    onDismiss={onHideDialog}
                    minWidth={800}
                    maxWidth={800}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-boxname-warning'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 800 } },
                    }}
                    >
                    <DialogContent>
                        { t('data-lang-msg-sectionstructurecreationalert') }
                    </DialogContent>
                    <DialogFooter>
                        <Row>
                            <Col className='col-auto ms-auto'>
                                <PrimaryButton onClick={onAcceptCreation} className='mx-1' text={t('data-lang-btn-accept')} />
                                <DefaultButton onClick={onHideDialog} className='mx-1' text={t('data-lang-btn-close')} />
                            </Col>
                        </Row>
                    </DialogFooter>
                </Dialog>
            }
        </>
    );
}

export default SectionCreationBox;